import { useGetQuery } from './useGetQuery';

interface OverviewResponse {
    month: string;
    inflow: number;
    outflow: number;
}

const useConnectedCashPositionOverview = () => {
    const { isLoading, entries } = useGetQuery<OverviewResponse[]>({
        url: 'banks/connect/cash-position',
        cacheKey: 'cash-position',
    });

    return { isLoading, entries };
};
export default useConnectedCashPositionOverview;
